export default __webpack_public_path__ + "static/media/IMG_8944.338ead85.jpg";